export default __webpack_public_path__ + "static/media/technology.5c5a67f7.jpg";